/* 
 * 车辆点火报警计划 
 * 描述： 
 * 创建时间：2017-04-10 
 * 创建人：baixx 
 * 修改时间：2017-04-11 
 */
<template>
	<div id="statusAlarmFire" class="wrapper wrapper-content animated fadeInRight tabBox">
		<div class="ibox-content" v-loading="loadingstatus.base||loadingstatus.mode||loadingstatus.period||loadingstatus.monitor" element-loading-text="加载中">
			<!--头部导航模块-->
			<div class="row">
				<div class="col-sm-12">
					<div class="alarm_process_icon">
						<ul>
							<li :class="{ active: stepOneActive, 'finish': !stepOneActive && stepOneStatus }"><i class="icon iconfont icon-jibenxinxi"></i><span>基本信息</span></li>
							<li :class="{ active: stepTwoActive, 'finish': !stepTwoActive && stepTwoStatus }"><i class="icon iconfont icon-baojingfangshi"></i><span>报警方式</span></li>
							<li :class="{ active: stepFourActive, 'finish': !stepFourActive && stepFourStatus }"><i class="icon iconfont icon-jiankongshiduan"></i><span>监控时段</span></li>
							<li :class="{ active: stepFiveActive, 'finish': !stepFiveActive && stepFiveStatus }"><i class="icon iconfont icon-jiankongcheliang"></i><span>监控车辆</span></li>
							<li :class="{ active: stepSixActive }"><i class="icon iconfont icon-wancheng"></i><span>完成</span></li>
						</ul>
					</div>
				</div>
			</div>
			<!--step-1:基本信息模块-->
			<div :style="{ display: stepOneActive?'block':'none' }">
				<AlarmPlanBase v-model="alarmBaseInfo" :imageData="imgdata" title="车辆点火报警" systemAlarms="当车辆在特定的条件下，发生点火行为时，触发系统报警。" bgClass="alarm_list_bg05"></AlarmPlanBase>
			</div>
			<!--step-2:报警方式模块-->
			<div :style="{ display: stepTwoActive?'block':'none' }">
				<AlarmPlanMode v-model="alarmModeInfo" :parentid="pageid"></AlarmPlanMode>
			</div>
			<!--step-3:监控时段模块-->
			<div :style="{ display: stepFourActive?'block':'none' }">
				<AlarmPlanPeriod v-model="alarmPeriodInfo" :parentid="pageid"></AlarmPlanPeriod>
			</div>
			<!--step-4:监控车辆模块-->
			<div :style="{ display: stepFiveActive?'block':'none' }">
				<AlarmPlanMonitor v-model="alarmMonitorInfo" :typeid="typeid"></AlarmPlanMonitor>
			</div>
			<!--step-6:完成-->
			<div :style="{ display: stepSixActive?'block':'none' }">
				<ul>
				  <li v-for="item in checkList" class="focus_color">
				    {{ item.step + ':' + item.message }}
				  </li>
				</ul>
			</div>
			<!--页脚控制部分-->
			<div class="row">
				<div class="col-sm-12 text-center pt10px">
					<button type="button" class="btn btn-primary " v-if="preBtnStatus" :disabled="operStatus" @click="preStep">上一步</button>
					<button type="button" class="btn btn-primary " v-if="nextBtnStatus" @click="nextStep">下一步</button>
					<button type="button" class="btn btn-primary " v-if="mode!=2 && finishBtnStatus" :disabled="operStatus" @click="saveAllInfo">{{operStatus?'保存完成':'保存'}}</button>
				</div>
			</div>
			<!--弹出框子组件-->
			<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
				{{messageStr}}
				<div slot="footer">
			        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
			    </div>
			</tab-modal>
		</div>
	</div>
</template>

<script>
	import Pagination from 'components/common/Pagination'
	import {ALARM_ICON_FIRE} from 'static/constant'
	import InputNumber from 'components/common/InputNumber'
	import Radio from 'components/common/Radio'
	import Checkbox from 'components/common/Checkbox'
	import TabModal from 'components/common/TabModal'
	import AlarmPlanBase from 'components/pages/vehiclealarm/common/AlarmPlanBase'
	import AlarmPlanMode from 'components/pages/vehiclealarm/common/AlarmPlanMode'
	import AlarmPlanPeriod from 'components/pages/vehiclealarm/common/AlarmPlanPeriod'
	import AlarmPlanMonitor from 'components/pages/vehiclealarm/common/AlarmPlanMonitor'
	import { OPERATE_SUCCESS,OPERATE_EXCEPTION} from 'static/message'
	import classlist from 'util/classlist'
	import {isPhone} from 'util/util'
	
	export default {
		name: 'PageStatusAlarmFire',
		components: {
			Pagination,
			InputNumber,
			Radio,
			Checkbox,
			TabModal,
			AlarmPlanBase,
			AlarmPlanMode,
			AlarmPlanPeriod,
			AlarmPlanMonitor
		},
		// 接收参数
		created(){
			this.mode = this.$route.query.mode;
			this.planid = this.$route.query.planid;
		},
		data() {
			return {
				loadingstatus:{
					base:false,
					mode:false,
					period:false,
					monitor:false
				},
				pageid:'statusAlarmFire',
				operStatus:false,				  //操作状态
				typeid:'5',
				planid:'',						  //报警计划ID
				mode:'0',						  //当前操作模式0：新建 1：编辑
				imgdata:ALARM_ICON_FIRE,
				stepIndex:1,                      //当前步骤索引
				stepMaxIndex:1,					  //最大步骤索引
				stepOneStatus:false,              //基本信息完成状态
				stepTwoStatus:false,              //报警方式完成状态
				stepFourStatus:false,             //监控时段完成状态
				stepFiveStatus:false,             //监控车辆完成状态
				//基本信息
				alarmBaseInfo: {
				},
				//报警方式
				alarmModeInfo: {
				},
				//监控时段
				alarmPeriodInfo: {
				},
				//监控车辆
				alarmMonitorInfo: {
				},
				//检查列表
				checkList:[],
				messageStr: "",					  // 弹出框内容
				scrollTop: '0'
			};
		},
		watch: {
        },
		computed: {
			//基本信息激活状态
			stepOneActive: function () {
		        return this.stepIndex===1;
		    },
		    //报警方式激活状态
		    stepTwoActive: function () {
		        return this.stepIndex===2;
		    },
		    
		    //监控时段激活状态
		    stepFourActive: function () {
		        return this.stepIndex===3;
		    },
		    //监控车辆激活状态
		    stepFiveActive: function () {
		        return this.stepIndex===4;
		    },
		    //完成激活状态
		    stepSixActive: function () {
		        return this.stepIndex===5;
		    },
		    //上一步按钮是否显示
		    preBtnStatus: function () {
		        return this.stepIndex!==1;
		    },
		    //下一步按钮是否显示
		    nextBtnStatus: function () {
		        return this.stepIndex!==5;
		    },
		    //完成按钮是否显示
		    finishBtnStatus: function () {
		        return this.stepIndex===5;
		    },
		},
		methods:{
			//下一步事件
			nextStep() {
				if (!this.checkAllInfo())return;
				this.stepIndex += 1;
				if (this.stepIndex > this.stepMaxIndex){
					this.stepMaxIndex = this.stepIndex;
				}
				this.stepOneStatus = this.stepMaxIndex >= 1;
				this.stepTwoStatus = this.stepMaxIndex > 2;
				this.stepFourStatus = this.stepMaxIndex > 3;
				this.stepFiveStatus = this.stepMaxIndex > 4;
			},
			//上一步事件
			preStep() {
				if (this.stepIndex===1){
					return;
				}
				this.stepIndex -= 1;
			},
			//检查信息
			checkAllInfo(){
				let result = true;
				//报警计划名称不能为空
				if (this.stepIndex==1 && this.alarmBaseInfo.alarmPlanName==''){
					this.openModalMsg("报警计划名称不能为空");
					result=false;
				}
				//报警方式
				if (this.stepIndex==2 && this.alarmBaseInfo.alarmLevel=='1' && this.checkAlarmMode()){
					this.openModalMsg("至少选择2种以上的报警方式");
					result=false;
				}
				//报警手机验证
				if (this.stepIndex==2 && this.alarmBaseInfo.alarmLevel=='1' && this.checkAlarmModePhone()){
					this.openModalMsg("手机号填写有错误");
					result=false;
				}
				//监控时段不可以为空
				if (this.stepIndex==3){
					if (this.alarmPeriodInfo.alarmPeriodList.length == 0){
						this.openModalMsg("没有添加监控时段");
						result=false;
					}else{
						let temp = this.alarmPeriodInfo.alarmPeriodList.filter(function(value, index, arr) {
						   return value.timerangeType == '9' || (value.timerangeType!='9' && value.isexclude=='1');
						})
						if (temp.length==0){
							this.openModalMsg("至少选择一个不限或者包含");
							result=false;
						}
					}
				}
				return result;
			},
			//保存
			saveAllInfo(){
	            //监控时段
	            let timerangeList=[];
	            this.alarmPeriodInfo.alarmPeriodList.forEach(function(item, i) {
	            	let every = {
	            		timerangeType:item.timerangeType,
	            		dateStart:item.datestart,
	            		dateEnd:item.dateend,
	            		frequency:item.alarmnumvalue,
	            		isAllday:item.isallday,
	            		isExclude:item.isexclude,
	            		limitEnable:item.limitEnable,
	            		timerangeStart:item.timerangestart,
	            		timerangeEnd:item.timerangeend,
	            		upperLimit:item.alarmcountvalue,
	            		weekDay:item.weekday
	            	}
	            	timerangeList.push(every);
	            });
	            //监控车辆
				let vehicleList =[];
				if (this.alarmMonitorInfo.alarmMonitorList){
					this.alarmMonitorInfo.alarmMonitorList.forEach(function(item, i) {
						let every = {
							vehicleId:item.vehicleId
						}
						vehicleList.push(every);
					});
				}
				
				let param={
					isAllVeh:this.alarmMonitorInfo.alarmMonitorMode,					//绑定车辆类型
					groups:JSON.stringify(this.alarmMonitorInfo.vehicleBranchInfo.vehicleBranchSelList),  //选择的分支id
					panelIds:this.alarmMonitorInfo.vehiclePanelInfo.vehiclePanelSelList,  	//选择的面板id
					planOwnerType:1,
					timeEnable:1,													//有监控时段，必填字段
					almLevel:this.alarmBaseInfo.alarmLevel,							//报警等级
					almType:this.typeid,											//报警种类
					planName:this.alarmBaseInfo.alarmPlanName,						//报警计划名称
					memo:this.alarmBaseInfo.alarmPlanNote,							//报警计划备注
					areaEnable:'0',													//区域限制
					customerId:this.$store.state.user.groupid,						//机构ID
					isEnable:this.alarmBaseInfo.alarmPlanStatus,					//计划状态
					mailEnable:this.alarmModeInfo.mailMode?1:0,					    //通过邮件报警
					mailList:this.alarmModeInfo.mailInfo,							//邮件列表
					msgEnable:this.alarmModeInfo.messageMode?1:0,					//通过短信报警
					msgList:this.alarmModeInfo.messageInfo,							//短信报警手机号列表
					telEnable:this.alarmModeInfo.phoneMode?1:0,						//电话报警
					telList:this.alarmModeInfo.phoneInfo,							//手机号列表
					weixinEnable:this.alarmModeInfo.weixinMode?1:0,					//微信报警
					weixinList:this.alarmModeInfo.weixinInfo,					    //微信列表
					areaList:[],												    //监控区域信息
					timerangeList:timerangeList,									//监控时段信息
					vehicleList:vehicleList,										//监控车辆信息
				} 
				this.loadingstatus.base = true;
			    if (this.mode=='0'){
					this.$http.post(process.env.API_ROOT + "/alarm/alarm-plans/almType/"+this.typeid, param)
					.then( res => {
						if(res.body.success){
							this.openModalMsg(OPERATE_SUCCESS);
							this.checkList.push(
								{
									step:"完成",
									message:"添加报警计划成功"
								}
							);
							this.operStatus = true;
						}else{
							this.openModalMsg(res.body.message);
						}
						this.loadingstatus.base = false;
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus.base = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus.base = false;
					})
				}
				if (this.mode=='1' || this.mode=='2'){
					param.id = this.planid;
					this.$http.put(process.env.API_ROOT + "/alarm/alarm-plans/almType/"+this.typeid, param)
					.then( res => {
						if(res.body.success){
							this.openModalMsg(OPERATE_SUCCESS);
							this.checkList.push(
								{
									step:"完成",
									message:"添加报警计划成功"
								}
							);
							this.operStatus = true;
						}else{
							this.openModalMsg(res.body.message);
						}
						this.loadingstatus.base = false;
					}, res => {
						this.openModalMsg(res.body.message);
						this.loadingstatus.base = false;
					}).catch( res => {
						this.openModalMsg(OPERATE_EXCEPTION);
						this.loadingstatus.base = false;
					})
				}
				
			},
			//报警方式选择
			checkAlarmMode(){
				let count =0;
				if(this.alarmModeInfo.mailMode){
					count++;
				}
				if(this.alarmModeInfo.messageMode){
					count++;
				}
				if(this.alarmModeInfo.weixinMode){
					count++;
				}
				if(this.alarmModeInfo.phoneMode){
					count++;
				}
				if (count>=2){
					return false;
				}else{
					return true;
				}
			},
			//报警方式手机验证
			checkAlarmModePhone(){
				let result = false;
				if(this.alarmModeInfo.messageMode){
					this.alarmModeInfo.messageInfo.split(",").forEach(function(item,index){
						if (!isPhone(item)){
							result = true;
						}
					})
				}
				if(this.alarmModeInfo.phoneMode){
					this.alarmModeInfo.phoneInfo.split(",").forEach(function(item,index){
						if (!isPhone(item)){
							result = true;
						}
					})
				}
				return result;
			},
			// 消息弹出框相关 
			openModal(ref) {
            	this.$refs[ref].open();
            	classlist.toggleScroll('close','#statusAlarmFire',this);
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        		classlist.toggleScroll('open','#statusAlarmFire',this);
        	},
        	closeModalMsg(){
        		this.closeModal("modalMsg");
        	},
        	openModalMsg(message){
        		this.messageStr = message;
        		this.openModal("modalMsg")
        	},
		}
	}
</script>

<style scoped>
	@import '../../../../assets/project/css/iconfont/iconfont.css';
     .grey_box label{
    	font-weight: normal;
    }
</style>



// WEBPACK FOOTER //
// PageStatusAlarmFire.vue?e7782d22